import React from "react";
import "./Module.css";
import IconWrapper from "./IconWrapper";

const Module = ({ icon, title, body }) => {
	const renderBody = () =>
		body.split("\n").map((line, i) => (
			<span key={i}>
				{line}
				{i < body.split("\n").length - 1 && <br />}
			</span>
		));

	return (
		<div className="module">
			<IconWrapper
				iconName={icon}
				className="module-icon-svg"
				width={72}
				height={72}
			/>
			<h3 className="module-title">{title}</h3>
			<p className="module-body">{renderBody()}</p>
		</div>
	);
};

export default Module;
